"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleProductCodesInList = exports.toggleProductCodeInList = void 0;
const toggleProductCodeInList = (code, list) => {
  if (list.includes(code)) {
    return list.filter(listItem => listItem !== code);
  }
  return [...list, code];
};
exports.toggleProductCodeInList = toggleProductCodeInList;
const toggleProductCodesInList = (codes, list) => codes.reduce((updatedList, code) => toggleProductCodeInList(code, updatedList), list);
exports.toggleProductCodesInList = toggleProductCodesInList;
//# sourceMappingURL=toggleProductCodeInList.js.map